import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

export default function AutocompleteField(props) {

  return (
    <Autocomplete
      {...props}
      onChange={props.onChange}
      options={props.options}
      onBlur={() => {}}
      renderInput={(params) =>
        <TextField
          {...params}
          label={props?.label}
          variant="outlined"
          error={props?.error}
          helperText={props?.helperText}
        />}
    />
  );
}
